import type { AppId } from "@/features/app/types/app-id";
import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import type {
  ExportAppsAlertsRequest,
  ExportAppsAlertsResponse,
  ListAppsAlertsUsersRequest,
  ListAppsAlertsUsersResponse,
} from "./type";

export async function getAppsAlertCounts() {
  const res = await apiClient.GET("/v2/app-alerts/count", {
    params: {},
  });

  const data = getDataOrThrowApiError(res);

  return {
    shadowIt: data?.SHADOW_IT ?? 0,
    noWorker: data?.NO_WORKER ?? 0,
    violatedAssignment: data?.VIOLATED ?? 0,
    violatedRole: data?.VIOLATED_ROLE ?? 0,
    noUser: data?.NO_USER ?? 0,
    inactive: data?.INACTIVE ?? 0,
  };
}

export async function listAppsAlertsUsers(
  params: ListAppsAlertsUsersRequest,
): Promise<ListAppsAlertsUsersResponse> {
  const res = await apiClient.GET("/v2/app-alerts/users", {
    params: {
      query: {
        ...params,
        // FIXME: ここのキャストなんとかしたい...
        appIdIn: params.appIdIn as AppId[],
      },
    },
  });

  return getDataOrThrowApiError(res);
}

// Refresh resources for all app integrations
export async function postRefreshResourcesAll() {
  const res = await apiClient.POST(
    "/v2/app-integrations/refresh-resources-all",
  );
  return getDataOrThrowApiError(res);
}

export async function exportAppsAlerts(
  params: ExportAppsAlertsRequest,
): Promise<ExportAppsAlertsResponse> {
  const res = await apiClient.GET("/v2/app-alerts-csv", {
    params: {
      query: {
        ...params,
        // FIXME: ここのキャストなんとかしたい...
        appIdIn: params.appIdIn as AppId[],
        mode: "view",
        encoding: "UTF-8",
      },
    },
  });

  return getDataOrThrowApiError(res);
}

// Refresh resources all - status
export async function getRefreshResourcesAllStatus() {
  const res = await apiClient.GET(
    "/v2/app-integrations/refresh-resources-all/status",
  );
  return getDataOrThrowApiError(res);
}
